// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}
.HomeStyle_homeContainer__nV0lu {
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 90%;
  margin: 35px auto;
  margin-bottom: 0px;
}
.HomeStyle_homeContaint__BsdxX {
  margin: 0px 30px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.HomeStyle_homeContaint__BsdxX h1 {
  /* margin-top: 20px; */
  color: var(--dark-color);
}
.HomeStyle_supportTicket__FPKqd {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%) rotate(180deg);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 15px;
  font-size: 16px;
  font-weight: 500;
  background: var(--primary);
  color: white;
  border-radius: 0px 10px 10px 0px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.HomeStyle_supportTicket__FPKqd span {
  display: inline-block;
  transition: transform 0.3s ease;
}
@keyframes HomeStyle_textShake__Norx5 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-2px);
  }
  50% {
    transform: translateY(2px);
  }
  75% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
}
.HomeStyle_supportTicket__FPKqd:hover span {
  animation: HomeStyle_textShake__Norx5 0.4s ease-in-out;
}

@media screen and (max-width: 480px) {
  .HomeStyle_homeContaint__BsdxX {
    margin: 0;
    /* You can keep overflow auto or remove it */
  }

  .HomeStyle_homeContaint__BsdxX h1 {
    margin-top: 0px;
  }
}

@media screen and (max-width: 360px) {
  .HomeStyle_homeContaint__BsdxX h1 {
    font-size: 24px;
  }
  .HomeStyle_supportTicket__FPKqd {
    top: auto;
    bottom: 34px;
    right: 0%;
    transform: translateX(0%) rotate(0deg);
    writing-mode: horizontal-tb;
    text-orientation: initial;
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    position: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Home/HomeStyle.module.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0CAA0C;EAC1C,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,sDAAqC;AACvC;;AAEA;EACE;IACE,SAAS;IACT,4CAA4C;EAC9C;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,YAAY;IACZ,SAAS;IACT,sCAAsC;IACtC,2BAA2B;IAC3B,yBAAyB;IACzB,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["html,\nbody {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n}\n.homeContainer {\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n  width: 90%;\n  margin: 35px auto;\n  margin-bottom: 0px;\n}\n.homeContaint {\n  margin: 0px 30px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.homeContaint h1 {\n  /* margin-top: 20px; */\n  color: var(--dark-color);\n}\n.supportTicket {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  transform: translateY(-50%) rotate(180deg);\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  padding: 15px;\n  font-size: 16px;\n  font-weight: 500;\n  background: var(--primary);\n  color: white;\n  border-radius: 0px 10px 10px 0px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.supportTicket span {\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n@keyframes textShake {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-2px);\n  }\n  50% {\n    transform: translateY(2px);\n  }\n  75% {\n    transform: translateY(-2px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.supportTicket:hover span {\n  animation: textShake 0.4s ease-in-out;\n}\n\n@media screen and (max-width: 480px) {\n  .homeContaint {\n    margin: 0;\n    /* You can keep overflow auto or remove it */\n  }\n\n  .homeContaint h1 {\n    margin-top: 0px;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .homeContaint h1 {\n    font-size: 24px;\n  }\n  .supportTicket {\n    top: auto;\n    bottom: 34px;\n    right: 0%;\n    transform: translateX(0%) rotate(0deg);\n    writing-mode: horizontal-tb;\n    text-orientation: initial;\n    width: 100%;\n    border-radius: 10px 10px 0px 0px;\n    text-align: center;\n    position: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeContainer": `HomeStyle_homeContainer__nV0lu`,
	"homeContaint": `HomeStyle_homeContaint__BsdxX`,
	"supportTicket": `HomeStyle_supportTicket__FPKqd`,
	"textShake": `HomeStyle_textShake__Norx5`
};
export default ___CSS_LOADER_EXPORT___;
